import { ISuitabilityReportData } from "@portal/types/robot/ISuitabilityReportData";
import { ISavingAgreementData } from "@portal/types/robot/ISavingAgreementData";
import { IRiskLevel } from "@portal/types/robot/IRiskLevel";
import { Language } from "@portal/types/robot/IRobotEnums";
import { ICustomerInfo } from "@portal/types/api/ICustomerInfo";
import { ICreateSavingsAgreement } from "@portal/types/api/ICreateSavingsAgreement";
import { CalculateStartUpAmountForFund } from "./GetStartUpAgreementRequest";
import { format } from "date-fns";

export const GetSuitabilityReport = (
  savingsAgreementRequest: ICreateSavingsAgreement,
  isDefaultLanguage: boolean,
  savingCalculationsRequest: ISavingAgreementData,
  riskLevelRequest: IRiskLevel,
  customerInfo?: ICustomerInfo,
) => {
  const suitabilityReportRequest = {
    customerNumber: customerInfo?.contactInfo.customerNumber,
    firstName: customerInfo?.firstname,
    lastName: customerInfo?.lastName,
    monthlyAmount: savingCalculationsRequest.monthlyAmount,
    riskLevel: savingCalculationsRequest.riskLevel,
    savingPeriod: riskLevelRequest.savingPeriod,
    sustainability: savingCalculationsRequest.sustainability,
    language: isDefaultLanguage ? Language.NB : Language.NN,
    oneTimePaymentInfo:
      savingCalculationsRequest.oneTimeDeposit > 0
        ? {
            bankAccountNumber: savingsAgreementRequest.agreementData.cashAccount,
            funds: savingsAgreementRequest.agreementData.funds.map(fund => ({
              amount: CalculateStartUpAmountForFund(savingCalculationsRequest.oneTimeDeposit, 1, fund),
              fundName: fund.name,
            })),
          }
        : undefined,
    savingsAgreementInfo:
      savingCalculationsRequest.monthlyAmount > 0
        ? {
            bankAccountNumber: savingsAgreementRequest.agreementData.otherCashAccount
              ? savingsAgreementRequest.agreementData.otherCashAccount
              : savingsAgreementRequest.agreementData.cashAccount,
            endDate: savingsAgreementRequest.agreementData.dateTo
              ? format(new Date(savingsAgreementRequest.agreementData.dateTo), "yyyy-MM-dd")
              : null,
            funds: savingsAgreementRequest.agreementData.funds.map(fund => ({
              amount: fund.amount,
              fundName: fund.name,
            })),
          }
        : undefined,
  } as ISuitabilityReportData;

  return suitabilityReportRequest;
};
